// Mercapoli - Delivery Earnings
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, DollarSign, TrendingUp, Package, Loader2 } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { delivery as deliveryApi } from '../../lib/api';

const DeliveryEarnings = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [ganancias, setGanancias] = useState(null);

  useEffect(() => {
    loadGanancias();
  }, []);

  const loadGanancias = async () => {
    try {
      const data = await deliveryApi.getGanancias();
      setGanancias(data);
    } catch (error) {
      console.error('Error:', error);
    }
    setLoading(false);
  };

  const stats = ganancias ? [
    { label: 'Hoy', entregas: ganancias.entregas_hoy, ganancias: ganancias.ganancias_hoy },
    { label: 'Esta semana', entregas: ganancias.entregas_semana, ganancias: ganancias.ganancias_semana },
    { label: 'Este mes', entregas: ganancias.entregas_mes, ganancias: ganancias.ganancias_mes },
    { label: 'Total', entregas: ganancias.total_entregas, ganancias: ganancias.total_ganancias },
  ] : [];

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 glass border-b border-border/50">
        <div className="container-app">
          <div className="flex items-center h-16 gap-4">
            <button onClick={() => navigate('/delivery')} className="p-2 -ml-2 rounded-lg hover:bg-muted">
              <ArrowLeft className="h-5 w-5" />
            </button>
            <h1 className="font-heading text-lg font-bold">Mis ganancias</h1>
          </div>
        </div>
      </header>

      <div className="container-app py-6">
        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-spicy-coral" />
          </div>
        ) : (
          <div className="space-y-6">
            {/* Total highlight */}
            <Card className="bg-gradient-to-r from-zesty-lime to-emerald-400 text-black">
              <CardContent className="p-6 text-center">
                <DollarSign className="h-10 w-10 mx-auto mb-2" />
                <p className="text-sm opacity-80">Ganancias totales</p>
                <p className="font-heading text-4xl font-bold">
                  ${ganancias?.total_ganancias?.toFixed(2) || '0.00'}
                </p>
                <p className="text-sm opacity-80 mt-1">
                  {ganancias?.total_entregas || 0} entregas completadas
                </p>
              </CardContent>
            </Card>

            {/* Breakdown */}
            <div className="space-y-3">
              {stats.map((stat) => (
                <Card key={stat.label}>
                  <CardContent className="p-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-muted-foreground text-sm">{stat.label}</p>
                        <p className="font-heading text-xl font-bold">
                          ${stat.ganancias?.toFixed(2) || '0.00'}
                        </p>
                      </div>
                      <div className="text-right">
                        <div className="flex items-center gap-1 text-muted-foreground">
                          <Package className="h-4 w-4" />
                          <span>{stat.entregas} entregas</span>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeliveryEarnings;
